var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronUpDownBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg5",
    viewBox: "0 0 24 24",
    height: "24px",
    width: "24px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs9"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1
    },
    transform: "translate(0.20338984,5.4915254)",
    id: "\\xC9l\\xE9ments"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000"
    },
    className: "st0-fill",
    id: "Icones/->/>bas/Fill/Noir"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    d: "m 12,16 c -0.256,0 -0.512,-0.098 -0.707,-0.293 l -6,-6 c -0.391,-0.391 -0.391,-1.023 0,-1.414 0.391,-0.391 1.023,-0.391 1.414,0 L 12,13.586 17.293,8.293 c 0.391,-0.391 1.023,-0.391 1.414,0 0.391,0.391 0.391,1.023 0,1.414 l -6,6 C 12.512,15.902 12.256,16 12,16"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1
    },
    transform: "rotate(180,12.152542,9.1524802)",
    id: "\\xC9l\\xE9ments-3"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000"
    },
    className: "st0-fill",
    id: "Icones/->/>bas/Fill/Noir-6"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-1-7",
    d: "m 12,16 c -0.256,0 -0.512,-0.098 -0.707,-0.293 l -6,-6 c -0.391,-0.391 -0.391,-1.023 0,-1.414 0.391,-0.391 1.023,-0.391 1.414,0 L 12,13.586 17.293,8.293 c 0.391,-0.391 1.023,-0.391 1.414,0 0.391,0.391 0.391,1.023 0,1.414 l -6,6 C 12.512,15.902 12.256,16 12,16"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUpDownBlack);
export default __webpack_public_path__ + "static/media/chevron-up-down-black.a81871d12132d0c17b0c88e15d680300.svg";
export { ForwardRef as ReactComponent };